import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import BarChart from '/src/components/Reusable/Charts/BarChart';
import { renderLockedFundingEvol } from '/src/components/LockedContent';
import { getFundingChartsData } from './helpers';
import { INVESTMENT_VEHICLE_COLORS, INVESTMENT_VEHICLE_FALLBACK_COLOR, OTHER_INVESTMENT_VEHICLES_LABEL } from './investmentVehicleColors';

const INITIAL_CHART_CONFIG = {
    id: 'funding-evolution',
    tooltip_keys: ['Date', 'Round', 'Investment Vehicle', 'Amount'],
    value_param: "amount",
    show_zero: true,
    category_colors: INVESTMENT_VEHICLE_COLORS,
    other_category_label: OTHER_INVESTMENT_VEHICLES_LABEL,
    other_category_color: INVESTMENT_VEHICLE_FALLBACK_COLOR,
    x: (d) => d.date_raised,
    y: (d) => d.amount,
    height: 360,
};

const FundingEvolutionChart = ({ fundingRounds, isLoggedIn, isStartupLoading, canViewChart, entityType, sectionRef, onLockedStateChange }) => {
    const [state, setState] = useState({
        fundingEvolutionChart: INITIAL_CHART_CONFIG,
        showFundingEvolutionChart: false,
    });

    useEffect(() => {
        if (fundingRounds) {
            getFundingChartsData(fundingRounds, setState);
        }
    }, [fundingRounds]);

    if (isLoggedIn && isStartupLoading) {
        return (
            <div id="section-funding" ref={sectionRef}>
                <div className="funding-chart profile-section-box">
                    <div className="funding-chart__content">
                        <h2 className="funding-chart__heading mb-20 profile-section-heading">Funding Evolution</h2>
                        <div style={{ display: 'flex', gap: 20, marginBottom: 16 }}>
                            <Skeleton width={130} height={12} />
                            <Skeleton width={150} height={12} />
                        </div>
                        <Skeleton height={240} borderRadius={6} />
                    </div>
                </div>
            </div>
        );
    }

    if (!isLoggedIn || !canViewChart) {
        return renderLockedFundingEvol(entityType, onLockedStateChange, sectionRef);
    }

    if (state.showFundingEvolutionChart) {
        return (
            <div id="section-funding" ref={sectionRef}>
                <div id="startup-funding-evolution" className="funding-chart profile-section-box">
                    <div className="funding-chart__content">
                        <div className="funding-chart__heading-row">
                            <h2 className="funding-chart__heading profile-section-heading">Funding Evolution</h2>
                            <span className="funding-chart__estimate-note">
                                <span className="funding-chart__estimate-note-swatch" />
                                Estimated (undisclosed)
                            </span>
                        </div>
                        <BarChart data={state.fundingEvolutionChart} />
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default FundingEvolutionChart;
